
import React, { useEffect, useState } from 'react'

interface Props {
  children: any
  fallback?: any
}

const NoSSR = ({ children, fallback = null }: Props): React.ReactElement => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => setMounted(true), [])

  if (!mounted) {
    return fallback
  }

  return children
}

export {
  NoSSR
}
